import { render, staticRenderFns } from "./EmployeeRegistry.vue?vue&type=template&id=42195db0&scoped=true&"
import script from "./EmployeeRegistry.vue?vue&type=script&lang=js&"
export * from "./EmployeeRegistry.vue?vue&type=script&lang=js&"
import style0 from "@/assets/rowHighlight.css?vue&type=style&index=0&lang=css&"
import style1 from "./EmployeeRegistry.vue?vue&type=style&index=1&id=42195db0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42195db0",
  null
  
)

export default component.exports